 import React, { useState } from 'react';
import {
  Col,
  Card,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';
import Home from './home.js';
import AddMembers from './addMembers.js';
import BranchManagement from './Branches/BranchManagement.jsx';
import { useCurrentUser } from '../../hooks/useCurrentUser';
  

  export default function Roles() {

  const [activeTab, setActiveTab] = useState('1');
  const decode = useCurrentUser();
  
 const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const [documentToggle,setDocumentToggle]=React.useState(false)


    return (

      <Card className="card" style={{width:"100%",height:'100%'}} >
    {/* {
    } */}
         <div style={{paddingLeft: '1em',paddingRight:'1em',marginTop:'1em'}}>
           <Nav tabs>
              <NavItem style={{backgroundColor:activeTab === '1' ? '#fff2f2' : '#fff'}}>
                <NavLink
                 style={{textDecoration:'none',borderBottom: activeTab === '1' ? '2px solid #D32028' : ''}}
                  className={activeTab === '1' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    toggle('1');
                  }}
                >
                <span  className={activeTab === '1' ? 'tabsHeadingClicked' : 'tabsHeading'}>All Members</span>

                </NavLink>
              </NavItem>

              <NavItem style={{backgroundColor:activeTab === '2' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '2' ? '2px solid #D32028' : ''}}
                  className={activeTab === '2' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    
                    toggle('2');
                  }}>
                  <span  className={activeTab === '2' ? 'tabsHeadingClicked' : 'tabsHeading'} >Roles & Permissions</span>
                </NavLink>
              </NavItem>
              {decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && 
              <NavItem style={{backgroundColor:activeTab === '3' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '3' ? '2px solid #D32028' : ''}}
                  className={activeTab === '3' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    
                    toggle('3');
                  }}>
                  <span  className={activeTab === '3' ? 'tabsHeadingClicked' : 'tabsHeading'} >Branches</span>
                </NavLink>
              </NavItem>
              }    
          
             
            </Nav>
           
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Col  sm="12">
                  <Home/>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Col sm="12" >
                   
                <AddMembers  activeTab={activeTab}/>
                  </Col>
                </Row>
              </TabPane>
               <TabPane tabId="3">
                {activeTab === "3" &&  <BranchManagement activeTab={activeTab}/>}
                </TabPane>
              </TabContent>
             </div>
  </Card>
    )

  }